<script setup lang="ts">
import { Head } from '@inertiajs/vue3'

import NotificationList from '@/components/notifications/NotificationList.vue'
import PortalLayout from '@/layouts/PortalLayout.vue'
import { destroyAllPortalPartnerNotificationsPath, portalPartnerNotificationPath, readAllPortalPartnerNotificationsPath, readPortalPartnerNotificationPath } from '@/routes'
import type { Notification } from '@/types'

defineProps<{ notifications: Notification[] }>()
</script>

<template>
  <Head title="Notifications" />
  <PortalLayout actor-type="partner">
    <NotificationList
      :notifications="notifications"
      :read-path="(id: number) => readPortalPartnerNotificationPath(id)"
      :read-all-path="readAllPortalPartnerNotificationsPath()"
      :delete-path="(id: number) => portalPartnerNotificationPath(id)"
      :delete-all-path="destroyAllPortalPartnerNotificationsPath()"
    />
  </PortalLayout>
</template>
